import getLastSegmentUrl from '#client/utils/getLastSegmentUrl';

/**
 * Compares the current entry page with a target page.
 *
 * @param {string} [targetPage=''] - The target page to compare with the current entry page.
 * @returns {boolean} - Returns true if the current entry page is equal to the target page, otherwise false.
 */
export const isCurrentPageEqualToTargetPage = (targetPage = '') => {
  const entryPage = getLastSegmentUrl(document.location.pathname);

  return entryPage === targetPage;
};
